import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createProject,
  getProjects,
  getProjectById,
  updateProject,
  deleteProject,
  getPlantationProjects,
  getPlantationProjectDetails,
  uploadPlantationCertificate,
} from "../api/project";

// Project Hooks
export const useCreateProject = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createProject(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["projects"]);
    },
  });
};

export const useGetProjects = () => {
  return useQuery({
    queryKey: ["projects"],
    queryFn: () => getProjects(),
    refetchOnWindowFocus: false,
  });
};

export const useGetProjectById = (id) => {
  return useQuery({
    queryKey: ["project", id],
    queryFn: () => getProjectById(id),
    enabled: !!id,
  });
};

export const useUpdateProject = (id) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => updateProject(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["projects"]);
    },
  });
};

export const useDeleteProject = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteProject(id),
    onSuccess: () => {
      queryClient.invalidateQueries(["projects"]);
    },
  });
};

export const useGetPlantationProjects = () => {
  return useQuery({
    queryKey: ["plantationProjects"],
    queryFn: () => getPlantationProjects(),
  });
}

export const useGetPlantationProjectDetails = (id) => {
  return useQuery({
    queryKey: ["plantationProjects"],
    queryFn: () => getPlantationProjectDetails(id),
  });
}

export const useUploadPlantationCertificate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => uploadPlantationCertificate(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["plantationProjects"]);
    },
  });
}